export const menuList = [
    {
        id: 1,
        path: "/",
        label: "Home",
        dropDown: false
    },
    {
        id: 2,
        path: "/about",
        label: "About",
        dropDown: false
    },
    {
        id: 3,
        path: "/classes",
        label: "Classes",
        dropDown: false
    },
    {
        id: 4,
        path: "/contact",
        label: "Contact",
        dropDown: false
    },
    {
        id: 5,
        path: "/partners",
        label: "Partners",
        dropDown: false
    },
]
